<main>
    <div class="container main-panel">
        <app-header-ad [position]="'top'"></app-header-ad>
        <div class="article-wrap" style="margin-right: 10px; margin-left: 10px">
            <div class="article-inner-container">
                <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
                <br />
                <h1>Lawshelf Blog - Video analyses of law-related news stories</h1>
                <hr />
                <span *ngFor="let video of shortVideos">
                    <div class="row">
                        <div *ngFor="let contentEntry of video.contentEntries" class="col-lg-4 col-md-6 col-sm-12 nav-panel-wrap">
                            <app-display-content-entry [area]="area" [selectedTopic]="video" [contentEntry]="contentEntry"></app-display-content-entry>
                        </div>
                    </div>
                </span>   
            </div>
        </div>
        <app-header-ad [position]="'bottom'"></app-header-ad>
    </div>
</main>
